import { render, staticRenderFns } from "./ThirdPartyShareList.vue?vue&type=template&id=3c86a1bc&scoped=true"
import script from "./ThirdPartyShareList.vue?vue&type=script&lang=js"
export * from "./ThirdPartyShareList.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyShareList.vue?vue&type=style&index=0&id=3c86a1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c86a1bc",
  null
  
)

export default component.exports